/** @type {string} */
export const BASE_URL = process.env.BASE_URL

/** @type {string} */
export const API_URL = process.env.VUE_APP_API_URL

/** @type {'de'|'en'} */
export const LANGUAGE = process.env.VUE_APP_LANGUAGE

/** @type {boolean} */
export const IS_IE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)

export const GAP_GIFT_CARD = 99
export const GAP_ALL_DAY = 100

// Keep up-to-date with variable in variables.scss.
export const BREAKPOINT_SIDEBAR = matchMedia('(min-width: 60rem)')

// Warn if a reservation is about to expire (in milliseconds).
export const RESERVATION_ABOUT_TO_EXPIRE = 2 * 60 * 1000

// Sentry configuration
export const SENTRY_DSN = process.env.SENTRY_DSN
export const SENTRY_TUNNEL = API_URL + 'bugs/'
export const SENTRY_ENVIRONMENT = process.env.VUE_APP_SENTRY_ENVIRONMENT
export const SENTRY_RELEASE = process.env.VUE_APP_SENTRY_RELEASE
export const SENTRY_SAMPLE_RATE = process.env.VUE_APP_SENTRY_SAMPLE_RATE
